import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Loader from '../ui/Loader';
import { SESSION_RELOGIN_MESSAGE } from '../../constants/sessionStateTypes';

function LoginForm({ onSubmit, isLoading, sessionStateMessage }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(username, password);
  };

  return (
    <div className="login__form">
      <div className="login__logo">&nbsp;</div>
      <h2 className="login__tag"><FormattedMessage id="login.welcome" />
        <span className="login__tag--strong"><FormattedMessage id="login.loginMessage" /></span>
      </h2>
      <form className="form" onSubmit={handleSubmit}>
        <fieldset>
          <input
            type="text"
            className="form__field"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            disabled={isLoading}
          />
          <input
            type="password"
            className="form__field form__field--pass"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            disabled={isLoading}
          />

          <div className="form__notification">
            { sessionStateMessage.includes(SESSION_RELOGIN_MESSAGE) ?
              <FormattedMessage id="general.reLogin" />
            : sessionStateMessage
            }
          </div>
          <button className="btn btn-primary" type="submit" disabled={isLoading}>{isLoading ? <Loader /> : <FormattedMessage id="general.login" />}</button>
        </fieldset>
      </form>
    </div>
  );
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  sessionStateMessage: PropTypes.string,
};

export default injectIntl(LoginForm);
